export default __webpack_public_path__ + "static/media/B147.df8ee91e.png";